import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { CartItem } from '../model/cart.model';
import { PriceChannel } from '../model/price-channel.model';

const maximumQuantityPrivate = 9999;
const maximumQuantityPublic = 9999999;
const influenzaMaxQuantity = 99999;
const base = 10;
const one = 1;
const two = 2;
let minQuantityforInfluenza = 0;
const DISABLED_IMG_SELECTOR = 'disabled-img';
const DISABLED_SELECTOR = 'disabled';

function prepareNoOfCartons(numberOfUnitsPerCarton: number, noOfCartonsElement: HTMLElement | null, orderValue: number): void {
  if (numberOfUnitsPerCarton > 0 && noOfCartonsElement) {
    const noOfCartons = orderValue / numberOfUnitsPerCarton;
    const cartonsTranslation = 'cx embarque';
    noOfCartonsElement.innerHTML = noOfCartons === 1 ? `<span class='red'>min 1 ${cartonsTranslation}</span>` : `${noOfCartons} ${cartonsTranslation}`;
  }
}

function getFields(idData: string): any {
  const inputElement = document.getElementById(`prodQuantity${idData}`) as HTMLInputElement;
  const numInputs = document.querySelectorAll('input[type=number]');

  numInputs.forEach(function(input) {
    input.addEventListener('change', function(e) {
      if ((e.target as HTMLInputElement).value === '') {
        (e.target as HTMLInputElement).value = '1';
      }
    });
  });

  const minusIcon = document.getElementById(`minusIcon${idData}`);
  const plusIcon = document.getElementById(`plusIcon${idData}`);
  const noOfDoses = document.getElementById(`noOfDoses${idData}`) as HTMLInputElement;
  const noOfCartonsElement = document.getElementById(`noOfCartons${idData}`) as HTMLInputElement;
  const unitMinus = document.getElementById(`unitMinus${idData}`);
  const unitMinusDisable = document.getElementById(`unitMinusDisable${idData}`);
  const unitPlus = document.getElementById(`unitPlus${idData}`);
  const unitPlusDisable = document.getElementById(`unitPlusDisable${idData}`);

  return { inputElement, minusIcon, plusIcon, noOfDoses, unitMinus, unitMinusDisable, unitPlus, unitPlusDisable, noOfCartonsElement };
}

function handleButtons(
  toggle: boolean,
  minusIcon: HTMLElement,
  unitMinus: HTMLElement,
  unitMinusDisable: HTMLElement,
  plusIcon: HTMLElement,
  unitPlus: HTMLElement,
  unitPlusDisable: HTMLElement
): void {
  minusIcon.classList.toggle(DISABLED_SELECTOR, toggle);
  unitMinus.classList.toggle(DISABLED_IMG_SELECTOR, toggle);
  unitMinusDisable.classList.toggle(DISABLED_IMG_SELECTOR, !toggle);
  plusIcon.classList.toggle(DISABLED_SELECTOR, !toggle);
  unitPlus.classList.toggle(DISABLED_IMG_SELECTOR, !toggle);
  unitPlusDisable.classList.toggle(DISABLED_IMG_SELECTOR, toggle);
}

function getOrderValue(operator: number, orderValue: number, numberOfUnitsPerCartonMoreThanZero: number): number {
  if (operator === one) {
    return (Math.ceil(orderValue / numberOfUnitsPerCartonMoreThanZero) * numberOfUnitsPerCartonMoreThanZero) + numberOfUnitsPerCartonMoreThanZero;
  }

  if (operator === two) {
    return (Math.ceil(orderValue / numberOfUnitsPerCartonMoreThanZero) * numberOfUnitsPerCartonMoreThanZero) - numberOfUnitsPerCartonMoreThanZero;
  }

  return Math.ceil(orderValue / numberOfUnitsPerCartonMoreThanZero) * numberOfUnitsPerCartonMoreThanZero;
}

function getInfluenzaOrderValue(operator: number, orderValue: number): number {
  if (operator === one) {
    return orderValue + 1;
  }

  if (operator === two && orderValue !== 0) {
    return orderValue - 1;
  }

  return orderValue;
}

export class ProductUtils {
  static alterQuantity(
    operator: number | null,
    idData: string,
    quantityOfUnits: number,
    priceChannel: PriceChannel,
    numberOfUnitsPerCarton = 0
  ): void {
    if (isNaN(quantityOfUnits)) {
      return;
    }
    const maxQuantityForChannel = ProductUtils.getMaximumQuantity(priceChannel);
    const maxQuantity =
      numberOfUnitsPerCarton > 0 ? maxQuantityForChannel - (maxQuantityForChannel % numberOfUnitsPerCarton) :
        maxQuantityForChannel;

    const {
      inputElement,
      minusIcon,
      plusIcon,
      noOfDoses,
      unitMinus,
      unitMinusDisable,
      unitPlus,
      unitPlusDisable,
      noOfCartonsElement
    } = getFields(idData);

    if (isNaN(inputElement.value)) {
      return;
    }

    let orderValue = parseInt(inputElement.value, base);

    const numberOfUnitsPerCartonMoreThanZero = numberOfUnitsPerCarton ? numberOfUnitsPerCarton : 1;
    const minimumQuantity = numberOfUnitsPerCartonMoreThanZero;

    orderValue = getOrderValue(operator, orderValue, numberOfUnitsPerCartonMoreThanZero);

    // icon changes
    if (orderValue <= minimumQuantity) {
      handleButtons(true, minusIcon, unitMinus, unitMinusDisable, plusIcon, unitPlus, unitPlusDisable);
      orderValue = minimumQuantity;
    } else if (orderValue >= maxQuantity) {
      orderValue = maxQuantity;
      handleButtons(false, minusIcon, unitMinus, unitMinusDisable, plusIcon, unitPlus, unitPlusDisable);
    } else {
      minusIcon.classList.remove(DISABLED_SELECTOR);
      plusIcon.classList.remove(DISABLED_SELECTOR);
      unitPlus.classList.remove(DISABLED_IMG_SELECTOR);
      unitMinus.classList.remove(DISABLED_IMG_SELECTOR);
      unitPlusDisable.classList.add(DISABLED_IMG_SELECTOR);
      unitMinusDisable.classList.add(DISABLED_IMG_SELECTOR);
    }

    prepareNoOfCartons(numberOfUnitsPerCarton, noOfCartonsElement, orderValue);

    // noOfDoses Check
    if (inputElement.value !== '') {
      inputElement.value = orderValue.toString();
    } else if (noOfDoses) {
      noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
    }
  }

  // Custom-Prpduct Refinement Category Formatting
  static categoryFormatting(data): any {
    const value = [];
    if (data.id === one || data.id === one.toString()) {
      value.push({ name: 'All', value: data.url });
    }
    data.subcategories?.forEach((obj) => {
      value.push({ name: obj.name, value: obj.url });
    });
    return value;
  }

  static alterQuantityforInfluenza(operator, idData, quantityOfUnits, page, cartFlag): void {
    minQuantityforInfluenza = page === 'cart' ? 1 : 0;

    if (isNaN(quantityOfUnits)) {
      return;
    }

    const { inputElement, minusIcon, plusIcon, noOfDoses, unitMinus, unitMinusDisable, unitPlus, unitPlusDisable } = getFields(idData);
    let orderValue = parseInt(inputElement?.value, base);

    if (isNaN(inputElement.value)) {
      return;
    }

   orderValue = getInfluenzaOrderValue(operator, orderValue);

    // icon chnages
    if (orderValue <= minQuantityforInfluenza) {
      handleButtons(true, minusIcon, unitMinus, unitMinusDisable, plusIcon, unitPlus, unitPlusDisable);
      if (orderValue === -1) {
        orderValue = minQuantityforInfluenza;
      }
    } else if (orderValue >= influenzaMaxQuantity) {
      handleButtons(false, minusIcon, unitMinus, unitMinusDisable, plusIcon, unitPlus, unitPlusDisable);
    } else {
      minusIcon.classList.remove(DISABLED_SELECTOR);
      plusIcon.classList.remove(DISABLED_SELECTOR);
      unitPlus.classList.remove(DISABLED_IMG_SELECTOR);
      unitMinus.classList.remove(DISABLED_IMG_SELECTOR);
      unitPlusDisable.classList.add(DISABLED_IMG_SELECTOR);
      unitMinusDisable.classList.add(DISABLED_IMG_SELECTOR);
    }

    if (page === 'cart' && orderValue < 1) {
      orderValue = 1;
    }

    // noOfDoses Check
    inputElement.value = orderValue?.toString();
    noOfDoses.innerHTML = `${orderValue * quantityOfUnits}  Doses`;

    if (orderValue === 0) {
      noOfDoses.innerHTML = '';
    }
  }

  static getMaximumQuantity(priceChannel: PriceChannel): number {
    return priceChannel === PriceChannel.PRIVATE ? maximumQuantityPrivate : maximumQuantityPublic;
  }

  static channelPrivateAndNumberUnitsPerCartonMoreThanOne(numberOfUnitsPerCarton: number, selectedChannel: PriceChannel): boolean {
    // return numberOfUnitsPerCarton && selectedChannel === PriceChannel.PRIVATE;
    return false; //TODO remove this line and uncomment one above to enable units per carton functionality
  }

  static checkIfQuantityIsCorrect(conditionsForCartonsLogicMeet: boolean, entries: CartItem, globalMessage: GlobalMessageService, errorMsgTimeout = 5000): CartItem {
    if (conditionsForCartonsLogicMeet && entries.quantity % entries.product.numberOfUnitsPerCarton) {
      const properQuantity = Math.ceil(entries.quantity / entries.product.numberOfUnitsPerCarton) * entries.product.numberOfUnitsPerCarton;

      globalMessage.add(
        { key: 'httpHandlers.cartWrongQuantityError' },
        GlobalMessageType.MSG_TYPE_ERROR, errorMsgTimeout
      );

      return { ...entries, quantity: properQuantity };
    }

    return entries;
  }

  static getUnitTranslation(channel: PriceChannel): string {
    return channel === PriceChannel.PUBLIC ? '(menor un)' : '(un)';
  }
}
